export default{

    DASHBOARD_TOP_BAR_FONT_COLOR:'green',
    DASHBOARD_THUMBS_UP_BACKGROUND_COLOR:'green',
    DASHBOARD_THUMBS_UP_FOREGROUND_COLOR:'white',
    MENU_SHARE_IMAGE_COLOR:'green',
}